import React from "react";

const BusinessStockMarketTrends = () => {
  return (
    <div style={styles.page}>
      {/* Hero Section */}
      <div style={styles.hero}>
        <h1 style={styles.heroTitle}>Business & Stock Market Trends</h1>
        <p style={styles.heroSubtitle}>
          Domestic and Global Market Outlook
        </p>
      </div>

      {/* Article Container */}
      <div style={styles.container}>
        <section style={styles.section}>
          <h2 style={styles.heading}>Introduction</h2>
          <p style={styles.text}>
            Business activity and stock market movements are key indicators of
            economic health in both domestic and global markets. Influenced by
            macroeconomic factors, geopolitical developments, corporate
            earnings, and investor sentiment, markets worldwide continue to
            evolve in a highly interconnected environment.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Domestic Market Trends</h2>
          <p style={styles.text}>
            Domestic stock markets are driven by economic growth, inflation
            trends, interest rate policies, government reforms, and corporate
            performance. Sectors such as banking, information technology,
            infrastructure, energy, and manufacturing play a crucial role in
            shaping market direction. Retail investor participation and
            systematic investment plans have strengthened market resilience.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Global Market Trends</h2>
          <p style={styles.text}>
            Global stock markets are influenced by monetary policies of major
            central banks, global trade dynamics, currency movements, and
            geopolitical tensions. Markets in the United States, Europe, and
            Asia remain closely linked, with developments in one region often
            impacting investor sentiment across the world.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Role of Inflation & Interest Rates</h2>
          <p style={styles.text}>
            Inflation and interest rates play a critical role in shaping
            business expansion and stock valuations. Rising interest rates
            increase borrowing costs and may slow economic growth, while stable
            inflation supports long-term investment and market confidence.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Technology & Innovation Impact</h2>
          <p style={styles.text}>
            Technology-led businesses continue to influence global markets
            through digital transformation, artificial intelligence, fintech,
            and automation. Innovation-driven companies often attract long-term
            investors due to scalability and future growth potential.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Investor Sentiment & Market Volatility</h2>
          <p style={styles.text}>
            Market sentiment is shaped by news, earnings reports, global
            conflicts, and economic data releases. Volatility remains a natural
            feature of financial markets, emphasizing the importance of
            diversification, risk management, and informed investment
            decisions.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Future Outlook</h2>
          <p style={styles.text}>
            The future of business and stock markets will depend on economic
            stability, policy support, technological progress, and global
            cooperation. Long-term investors are expected to focus on
            fundamentals, sustainability, and innovation-driven growth.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Conclusion</h2>
          <p style={styles.text}>
            Domestic and global stock markets reflect the dynamic nature of the
            world economy. While short-term fluctuations are inevitable,
            disciplined investing, strong business fundamentals, and awareness
            of global trends remain key to navigating market opportunities
            successfully.
          </p>
        </section>
      </div>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '20px', marginBottom: '20px' }}>
          <p style={{ fontSize: '0.75rem', color: '#64748b', fontStyle: 'italic', margin: '0 0 20px 0' }}>
            Article by <strong>Mangalorehub.com Business Correspondent</strong>
          </p>
        </div>
        © 2026 Business & Markets | Current Affairs
      </footer>
    </div>
  );
};

const styles = {
  page: {
    fontFamily: "'Inter', Arial, sans-serif",
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
    color: "#0f172a",
  },
  hero: {
    background: "linear-gradient(135deg, #0f766e, #115e59)",
    color: "#ffffff",
    textAlign: "center",
    padding: "25px 20px",
  },
  heroTitle: {
    fontSize: "1.4rem",
    fontWeight: "600",
    marginBottom: "10px",
  },
  heroSubtitle: {
    fontSize: "1.0rem",
    opacity: 0.9,
  },
  container: {
    maxWidth: "900px",
    margin: "-40px auto 0",
    background: "#ffffff",
    borderRadius: "16px",
    padding: "40px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  },
  section: {
    marginBottom: "35px",
  },
  heading: {
    fontSize: "1.2rem",
    color: "#0f766e",
    borderLeft: "4px solid #0f766e",
    paddingLeft: "12px",
    marginBottom: "10px",
  },
  text: {
    fontSize: ".85rem",
    lineHeight: "1.5",
  },
  footer: {
    textAlign: "center",
    margin: "40px 0",
    fontSize: "0.9rem",
    color: "#64748b",
  },
};

export default BusinessStockMarketTrends;
